import type { Namespace } from "@/i18n/types";
import nsAuthEN from "./en";
import nsAuthJA from "./ja";

export const nsAuth = {
  name: "auth",
  locales: {
    ja: nsAuthJA,
    en: nsAuthEN,
  },
} satisfies Namespace<"auth", typeof nsAuthJA>;
